// @flow

import axios      from 'axios';
import RoutesAPI  from './Routes';

let API_URL = '';
if( process.env.REACT_APP_API_URL ) {
  API_URL = process.env.REACT_APP_API_URL;
}

// Requests
const requests = {
  get: (url: string, body: any) => {
    return axios.get(API_URL + url, body);
  },

  put: (url: string, body: any, headers: any) => {
    return axios.put(API_URL + url, body, headers);
  }
};

const ApplicationsAPI = {
  getApplications: () => {
    return requests.get(RoutesAPI.get_applications());
  },

  newActivitiesChecked: (id: number) => {
    return requests.put(RoutesAPI.mark_new_activities_as_seen(id))
  },
}

export default ApplicationsAPI;



// WEBPACK FOOTER //
// ./src/api/applicationsAPI.js